export { default as CloudUploadOutlineIcon } from './CloudUploadOutlineIcon';
